// Module
var code = "<div class=\"widget-content\"> <wt-scatter-plot chart-data=\"vm.data\" disable-crosshair=\"vm.disableCrosshair\" id=\"{{'id'+vm.item.guid}}\" options=\"vm.options\" ratio=\"vm.ratio\" series=\"vm.series\" shapes=\"vm.shapes\" zoom-control=\"vm.item\"> </wt-scatter-plot> </div>";
// Exports
module.exports = code;